import { useLayoutEffect, useState, type RefObject } from "react";

/**
 * The element's content width in pixels, kept current by a `ResizeObserver`;
 * `null` until the first measurement. The one DOM read in the timeline: it
 * sizes the clustering and tick-density thresholds, never a position.
 */
export function useElementWidth(
  ref: RefObject<HTMLElement | null>,
): number | null {
  const [width, setWidth] = useState<number | null>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    setWidth(element.clientWidth);
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        setWidth(entry.contentRect.width);
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return width;
}
